import React from 'react';
import { getBallotOptionLabel, getBallotOptionImage } from './VoteTypeUtils.js'

export const VoteSingleSelect = ({ options, hasVoted, onOptionsUpdate, group }) => {
    const handleSelect = (event) => {
        // Selected id clicked
        const selectedId = parseInt(event.target.value)

        // Clone the array
        const selectOptions = [...options]

        // Clone and update each one (only 1 can be ticked)
        for (let i = 0; i < selectOptions.length; i++) {
            selectOptions[i] = { ...selectOptions[i] }
            selectOptions[i].score = selectOptions[i].ballotOptionId === selectedId ? 1 : 0
        }

        // Notify update
        onOptionsUpdate(selectOptions)
    }

    return (
        <React.Fragment>
            {options.map((option) =>
                <div key={option.ballotOptionId} className="mb-4 flex items-start">
                    {getBallotOptionImage(group, option)}
                    <input type="radio"
                        id={option.ballotOptionId}
                        name="ballot-single"
                        value={option.ballotOptionId}
                        disabled={hasVoted}
                        checked={option.score > 0}
                        onChange={handleSelect}
                        className="align-top" />
                    <label htmlFor={option.ballotOptionId}
                        className="cursor-pointer disabled:cursor-default flex-1">
                        {getBallotOptionLabel(group, option)}
                    </label>
                </div>
            )}
        </React.Fragment>
    );
}